import { SocketContext } from "@/Context/SocketContext";
import { useContext } from "react";

export const useSocket = () => {
    return useContext(SocketContext);
}